import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('alertStore', [
      'addAlert',
      'addErrorAlert',
      'addSuccessAlert',
      'addWarningAlert',
    ]),
  },
}
